import { render, staticRenderFns } from "./PurchaseCurrencies.vue?vue&type=template&id=653ee8f7&"
import script from "./PurchaseCurrencies.vue?vue&type=script&lang=ts&"
export * from "./PurchaseCurrencies.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports